import React, { useState } from "react";
import { AdvancedFilter, Select, DateRangePicker } from "@kaleyra/emmy";
import { useTranslation } from "react-i18next";
import moment,{ Moment } from "moment";
import { InjectedPropsType } from '@kaleyra/emmy/dist/molecules/advancedFilter';
import Styles from './index.module.scss';

type FiltersName = 'status' | 'created_at' ;

const BulkUploadFilter = ({appliedFilters, onFilter}: any) => {
    const { t } = useTranslation();
    const [filterDateText, setFilterDateText] = useState<any>('');

    let updatedCreatedDate = filterDateText;
	if (filterDateText) {
		let createdArr = filterDateText.split(',');
		let startDate = moment(createdArr[0], 'YYYY-MM-DD HH:mm:ss');
		let endDate = moment(createdArr[1], 'YYYY-MM-DD HH:mm:ss');
		updatedCreatedDate = [startDate, endDate];
	}

    const statusOptions = () => {
        return [
            {
                label:"Completed",   
                value:"1"
            },
            {
                label:"Pending",  
                value:"0"
            },
            {
                label:"Processing",   
                value:"2"
            },
            {
                label:"Failed",   
                value:"3"
            },
        ]
    }

    const onChange = (
        changeFilters: (filters: Record<string, any>) => void, filters: Record<string, string> | undefined
    ) => (field: FiltersName, custom?: boolean) => (value: any) => {
        const newFilters = {
            ...filters,
            [field]: custom
                ? (value as React.ChangeEvent<HTMLInputElement>).target.value
                : value,
        };
        changeFilters(newFilters);
    };

    const onDateChange = (
		changeFilters: (filters: Record<string, any>) => void, filters: Record<string, string> | undefined
	) => (field: FiltersName, custom?: boolean) => (value: any) => {
			const [start, end] = value;
			if (start && end) {
				const formattedDate = `${start
					.startOf('day')
					.format('YYYY-MM-DD HH:mm:ss')},${end
					.endOf('day')
					.format('YYYY-MM-DD HH:mm:ss')}`;
				setFilterDateText(formattedDate);
				const newFilters = {
					...filters,
					[field]: formattedDate,
				};
				changeFilters(newFilters);
			}
	};
    
    const renderFormBody = ({
        changeFilters,
        filters,
    }: InjectedPropsType): JSX.Element => {
        const onFilterChange = onChange(changeFilters, filters);
    
        const onDateFilterChange = onDateChange(changeFilters, filters);
    
        return (
            <div className={Styles.container}>
                <div>
                    <Select
                        placeholder={t('KLR02832')}
                        label={t('KLR02832')}
                        value={filters?.status}
                        onChange={onFilterChange('status')}
                        options={statusOptions()}
                        showBottomLabelSpace={false}
                        className={Styles.inputField}
                    />
                </div>
                <div>
                    <span className={Styles.dateLabel}>
                        {t('camCreatedOn')}
                    </span>
                    <DateRangePicker
                        onOk={onDateFilterChange('created_at')}
                        value={filters?.created_at ? updatedCreatedDate : ''}
                        formatForDatePicker={'DD MM YYYY'}
                        style={{ width: '100%', marginTop: '0.25rem' }}
                        disabledDate={(current: any) => {
                            return current && current > moment().endOf('day');
                        }}
                        onClear={() => onDateFilterChange('created_at')}
                        showBottomLabelSpace={false}
                    />
                </div>
            </div>
        );
    };

    return (
		<AdvancedFilter
			appliedFilters={appliedFilters}
			onFilter={onFilter}
			filterTitle={t('mainFilter')}
			cancelButtonText={t('mainCancel')}
			confirmButtonText={t('BLD01036')}
		>
			{renderFormBody}
		</AdvancedFilter>
	);
}

export default BulkUploadFilter;